import { getAddress } from 'ethers';
const RAW_TOKENS = [
    {
        chain: 'polygon',
        symbol: 'USDT',
        address: '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
        decimals: 6,
        native: false,
    },
    {
        chain: 'polygon',
        symbol: 'USDC',
        address: '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359',
        decimals: 6,
        native: true,
    },
    {
        chain: 'base',
        symbol: 'USDT',
        address: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
        decimals: 6,
        native: true,
    },
    {
        chain: 'base',
        symbol: 'USDC',
        address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        decimals: 6,
        native: true,
    },
    {
        chain: 'arbitrum',
        symbol: 'USDT',
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        decimals: 6,
        native: false,
    },
    {
        chain: 'arbitrum',
        symbol: 'USDC',
        address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        decimals: 6,
        native: true,
    },
    {
        chain: 'optimism',
        symbol: 'USDT',
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        decimals: 6,
        native: false,
    },
    {
        chain: 'optimism',
        symbol: 'USDC',
        address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        decimals: 6,
        native: true,
    },
    {
        chain: 'bsc',
        symbol: 'USDT',
        address: '0x55d398326f99059ff775485246999027b3197955',
        decimals: 18,
        native: false,
    },
    {
        chain: 'bsc',
        symbol: 'USDC',
        address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        decimals: 18,
        native: false,
    },
    {
        chain: 'avalanche',
        symbol: 'USDT',
        address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        decimals: 6,
        native: false,
    },
    {
        chain: 'avalanche',
        symbol: 'USDC',
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        decimals: 6,
        native: true,
    },
    // --- Testnets (Circle / Tether resmi faucet adresleri) ---
    {
        chain: 'polygon-amoy',
        symbol: 'USDC',
        address: '0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582',
        decimals: 6,
        native: true,
    },
    {
        chain: 'base-sepolia',
        symbol: 'USDC',
        address: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
        decimals: 6,
        native: true,
    },
    {
        chain: 'arbitrum-sepolia',
        symbol: 'USDC',
        address: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
        decimals: 6,
        native: true,
    },
];
export const TOKENS = RAW_TOKENS.map((t) => ({
    ...t,
    address: getAddress(t.address),
}));
export function getToken(chain, symbol) {
    const token = TOKENS.find((t) => t.chain === chain && t.symbol === symbol);
    if (!token) {
        // Surface every detail so blank-screen debugging in a production
        // SPA gives the integrator something to act on. The available
        // pairs list lets you spot a typo ('Polygon' vs 'polygon') or a
        // missing entry in one glance.
        const available = TOKENS.map((t) => `${t.chain}/${t.symbol}`).join(', ');
        throw new Error(`Token ${JSON.stringify(symbol)} not configured on ${JSON.stringify(chain)}. ` +
            `Available: ${available}`);
    }
    return token;
}
export function getTokensForChain(chain) {
    return TOKENS.filter((t) => t.chain === chain);
}
export function findTokenByAddress(chain, address) {
    const checksummed = getAddress(address);
    return TOKENS.find((t) => t.chain === chain && t.address === checksummed);
}
//# sourceMappingURL=index.js.map